var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.99 12.745c.55 0 1 .45 1 1v2.85l3.55-3.55a.996.996 0 1 1 1.41 1.41l-3.54 3.54h2.83c.55 0 1 .45 1 1s-.45 1-1 1H5.87c-1.03 0-1.88-.84-1.88-1.88v-4.37c0-.55.45-1 1-1m13.14-8.74c1.03 0 1.88.84 1.88 1.88v4.38c0 .55-.45 1-1 1l-.01-.01c-.55 0-1-.45-1-1v-2.84l-3.55 3.55a.98.98 0 0 1-.705.289 1.02 1.02 0 0 1-.705-.29.996.996 0 0 1 0-1.41l3.55-3.55h-2.84c-.55 0-1-.45-1-1s.45-1 1-1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 11.255h-.01l.005-.001z"
})));
export default SvgIcExpand;